import styled from 'styled-components';
import { COLOR_CODE_BY_ID } from '../../constants';

const ColorButton = styled.button`
  background-color: ${({ $background_color }) => `#${COLOR_CODE_BY_ID[$background_color]}`}
`;

export default ColorButton
